import React, { useState } from "react";

import NavLinks from "../components/NavLinks";
import Button from "../../shared/Button";
import SideMenu from "../components/SideMenu";
import logo from "../../assets/image/logo.svg";
import Hamburger from "../components/Hamburger";

import "./Header.css";

const Header = () => {
  const [open, setOpen] = useState(false);

  const openHandler = () => {
    setOpen(true);
  };
  const closeHandler = () => {
    setOpen(false);
  };

  return (
    <div className="header-container">
      <Hamburger onClick={openHandler} />
      <img className="logo" src={logo} alt="logo" />
      <SideMenu style={open ? { left: 0 } : null} Close={closeHandler} />
      <NavLinks className="navlinks" />
      <div className="btn-wrapper">
        <Button btn="Sign In" className="btn-signin" />
        <Button btn="Sign Up" className="btn-signup" />
      </div>
    </div>
  );
};

export default Header;
